export const menu = [
  {
    name: "Mi perfil",
    icon: "mdi-home-outline",
    to: "perfil",
    header: "PERFIL",
    headerShort: "PE",
    counter: -1,
    counter_b: false,
  },

  {
    name: "Soporte/Mantención",
    icon: "mdi-file-cog-outline",
    to: "soporte",
    header: "TICKETS",
    headerShort: "TI",
    counter: "ticket_soporte",
    counter_b: true,
    visible_bit: "b_soporte",
  },
  {
    name: "Nuevos Desarrollos",
    icon: "mdi-file-code-outline",
    to: "desarrollos",
    header: null,
    counter: "ticket_desarrollo",
    counter_b: true,
    visible_bit: "b_desarrollo",
  },
  {
    name: "Desarrollo Cliente",
    icon: "mdi-file-account-outline",
    to: "desarrollo-cliente",
    header: null,
    counter: "ticket_postproduccion",
    counter_b: true,
    visible_bit: "b_desarrollo_cliente",
  },
  {
    name: "Actualización",
    icon: "mdi-file-refresh-outline",
    to: "actualizacion",
    header: null,
    counter: "ticket_actualizacion",
    counter_b: true,
    visible_bit: "b_actualizacion",
  },
  {
    name: "Cotización/Mejoras",
    icon: "mdi-file-chart-outline",
    to: "cotizacion",
    header: null,
    counter: "ticket_cotizacion",
    counter_b: true,
    visible_bit: "b_cotizacion",
  },
  {
    name: "Capacitaciones/Reuniones",
    icon: "mdi-file-certificate-outline",
    to: "capacitacion",
    header: null,
    counter: "ticket_capacitacion",
    counter_b: true,
    visible_bit: "b_capacitacion",
  },
  {
    name: "Biblioteca",
    icon: "mdi-file-document-multiple-outline",
    to: "biblioteca",
    header: null,
    counter: "ticket_biblioteca",
    counter_b: false,
    visible_bit: "b_biblioteca",
  },
  {
    name: "Consulta Requerimientos",
    icon: "mdi-file-search-outline",
    to: "informe",
    counter: -1,
    counter_b: false,
    visible_bit: "b_informe",
  },
];
